import App from '@app/app';

export class PersistentCartPreprocessorService {
  preprocess(persistedOrders) {
    persistedOrders.forEach((order) => {
      order.addOns = order.addOns?.filter((addOn) => !addOn.orderable?.freeGift);
    });

    return persistedOrders;
  }
}

App.service('PersistentCartPreprocessorService', PersistentCartPreprocessorService);
